/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from 'react';

const LegendPage = props => {
    let backButton = null;

    if (props.history && props.history.goBack) {
        backButton = (
            <a
                onClick={() => {
                    props.history.goBack();
                }}>
                <i className="fa fa-chevron-circle-left" /> Back
            </a>
        );
    }

    return (
        <main className="page">
            <div className="page__body">
                <h2>PCMHGuide Threshold Calculations</h2>
                {backButton}
                <p>
                    PCMHGuide status calculations are made with the following
                    schedule.
                </p>

                <h3>Not Started</h3>
                <p>
                    Criteria with the status of "Not Started" (the default
                    status) will trigger the following based on the number of
                    days until the upcoming check-in
                </p>
                <ul>
                    <li>
                        <strong>21 Days</strong> - Warning
                    </li>
                    <li>
                        <strong>14 Days</strong> - Danger
                    </li>
                </ul>

                <h3>Started</h3>
                <p>
                    Criteria with the status of "Started" will trigger the
                    following based on the number of days until the upcoming
                    check-in
                </p>
                <ul>
                    <li>
                        <strong>14 Days</strong> - Warning
                    </li>
                    <li>
                        <strong>7 Days</strong> - Danger
                    </li>
                </ul>

                <h3>Revision Required</h3>
                <p>
                    Criteria with the status of "Revision Required" will trigger
                    the following based on the number of days until the upcoming
                    check-in
                </p>
                <ul>
                    <li>
                        <strong>14 Days</strong> - Warning
                    </li>
                    <li>
                        <strong>7 Days</strong> - Danger
                    </li>
                </ul>

                <h3>Review Ready</h3>
                <p>
                    Criteria with the status of "Review Ready" will trigger the
                    following based on the number of days until the upcoming
                    check-in
                </p>
                <ul>
                    <li>
                        <strong>7 Days</strong> - Warning
                    </li>
                    <li>
                        <strong>2 Days</strong> - Danger
                    </li>
                </ul>
            </div>
        </main>
    );
};

export default LegendPage;
